/**
 *
 * Asynchronously loads the component for Financial Services
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
